import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/usr/src/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import ShopPageHeader from '../../components/shop-page-header/shop-page-header';
import { UtilsInfiniteScroll } from '@vc-workspace/utils-infinite-scroll';
import { DesktopFooter } from '@vc-workspace/desktop-footer';
import { MobileFooter } from '@vc-workspace/mobile-footer';
import { getQueryValueAsString } from '@vc-workspace/utils-helpers';
import { CategoryFilterKey, SortByKey, PriceFilterKey, DiscountFilterKey, PageTypes, SourceKey, SourceNameKey, FilterTypes, INTERNAL_NAVIGATION_UTM_MEDIUM, UtmParams } from '@vc-workspace/utils-constants';
import { useEffect } from 'react';
import { AmplitudeEventNames, sendAmplitudeData } from '@vc-workspace/utils-amplitude';
import EmptyResults from '../../components/empty-results/empty-results';
import GlobalContextWrapper from '../../components/global-context-wrapper/global-context-wrapper';
import { getProducts } from '@vc-workspace/data-adapter';
import ShopCatalogueSection from '../../components/shop-catalogue-section/shop-catalogue-section';
import ShopCatalogueBubbles from '../../components/shop-catalogue-bubbles/shop-catalogue-bubbles';
import { UtilsSeparator } from '@vc-workspace/utils-separator';
import { DIMENSIONS } from '@vc-workspace/utils-dimens';
import CategoryFilters from '../../components/category-filters/category-filters';
import { Pagination } from '@vc-workspace/pagination';
import { UtilsStickyBottomCta } from '@vc-workspace/utils-sticky-bottom-cta';
import SortFilterModalSheet from '../../components/sort-filter-modal-sheet/sort-filter-modal-sheet';
import FilterModalDialog from '../../components/filter-modal-dialog/filter-modal-dialog';
import { getFiltersPayload } from '../../components/helpers/helpers';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { PageCacheKeys } from '../../components/marketplace-constants/marketplace-constants';
import BasicSEO from '../../components/seo/BasicSEO';
import { PageLoader } from '@vc-workspace/utils-loader';
import ProductStackList from '../../components/product-stack-list/product-stack-list';
var ITEMS_PER_SECTION = 12;
var MIN_COLLECTIONS_FOR_DISPLAY = 2;
var DEFAULT_PAGINATION_LIMIT = 40;

function getShelfDataRequestPayload(shopSlug, shelfSlug) {
  return {
    shopSlug: shopSlug,
    shelfSlug: shelfSlug,
    filters: [],
    start: 0,
    limit: ITEMS_PER_SECTION
  };
}

function fetchProductsForPages(shop, currPage, context) {
  if (!currPage) {
    currPage = 1;
  }

  var reqPayload = _objectSpread({
    shopSlug: shop.slug,
    start: DEFAULT_PAGINATION_LIMIT * (currPage - 1),
    limit: DEFAULT_PAGINATION_LIMIT,
    getFilters: true
  }, getFiltersPayload(context));

  return getProducts(reqPayload);
}

function ShopCollectionPage(props) {
  var _useInfiniteQuery = useInfiniteQuery([PageCacheKeys.SHOP_PAGE, props.context.params[0], JSON.stringify(props.context.query)], function (_ref) {
    var _ref$pageParam = _ref.pageParam,
        pageParam = _ref$pageParam === void 0 ? 1 : _ref$pageParam;
    return getProducts(getShelfDataRequestPayload(props.shop.slug, props.catalogues[pageParam - 1].slug));
  }),
      data = _useInfiniteQuery.data,
      fetchNextPage = _useInfiniteQuery.fetchNextPage,
      isLoading = _useInfiniteQuery.isLoading;

  var onNextClick = function onNextClick(nextPage) {
    fetchNextPage({
      pageParam: nextPage
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!props.catalogues.length ? /*#__PURE__*/_jsx(EmptyResults, {
      context: props.context
    }) : null, /*#__PURE__*/_jsx(ShopCatalogueBubbles, {
      catalogues: props.catalogues,
      context: props.context,
      shop: props.shop,
      firstSIA: props.siasResponse.sias[0],
      offers: props.offers
    }), !props.context.isMobileView ? /*#__PURE__*/_jsx(UtilsSeparator, {
      spacingTop: DIMENSIONS.px_24,
      spacingBottom: DIMENSIONS.px_24,
      color: "gainsboro"
    }) : /*#__PURE__*/_jsx("div", {
      className: "pt-12"
    }), data && data.pages.map(function (page, index) {
      return /*#__PURE__*/_jsx(ShopCatalogueSection, {
        context: props.context,
        shop: props.shop,
        catalogue: props.catalogues[index],
        sias: page.sias,
        hasMoreProducts: page.siasCount > ITEMS_PER_SECTION,
        cataloguePosition: index
      }, index);
    }), data && data.pages.length < props.catalogues.length ? /*#__PURE__*/_jsx(UtilsInfiniteScroll, {
      currPage: data.pages.length,
      callback: onNextClick,
      gridCount: props.context.isMobileView ? 2 : 6,
      disableDefaultGutter: true
    }) : null, isLoading && !data ? /*#__PURE__*/_jsx(PageLoader, {}) : null]
  });
}

export var __N_SSP = true;
export function ShopPage(props) {
  var _props$siasResponse, _props$siasResponse$s, _props$siasResponse2;

  useEffect(function () {
    sendAmplitudeData(AmplitudeEventNames.PAGE_VIEWED, {
      page_type: PageTypes.MARKETPLACE_SHOP_PAGE,
      page_name: props.shop.name,
      page_identifier: props.shop.slug,
      shop_id: props.shop._id,
      shop_name: props.shop.name,
      page_num: props.currPage,
      price_filter: getQueryValueAsString(props.context.query, PriceFilterKey),
      discount_filter: getQueryValueAsString(props.context.query, DiscountFilterKey),
      sort_filter: getQueryValueAsString(props.context.query, SortByKey),
      category_filter: getQueryValueAsString(props.context.query, CategoryFilterKey),
      source: getQueryValueAsString(props.context.query, SourceKey),
      source_name: getQueryValueAsString(props.context.query, SourceNameKey),
      has_shop_review: Boolean(props.shop.totalRatings)
    });
  }, []);
  var showCollectionDisplay = props.catalogues.length >= MIN_COLLECTIONS_FOR_DISPLAY;
  return /*#__PURE__*/_jsxs(GlobalContextWrapper, {
    context: props.context,
    attributionData: {
      allowed: true,
      query: props.context.query,
      page_type: PageTypes.MARKETPLACE_SHOP_PAGE,
      page_id: props.shop._id
    },
    children: [/*#__PURE__*/_jsx(BasicSEO, {
      title: props.shop.name,
      shopId: props.shop._id
    }), /*#__PURE__*/_jsx("link", {
      rel: "stylesheet",
      type: "text/css",
      href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
    }), /*#__PURE__*/_jsx("link", {
      rel: "stylesheet",
      type: "text/css",
      href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
    }), /*#__PURE__*/_jsx(ShopPageHeader, {
      shop: props.shop,
      context: props.context
    }), /*#__PURE__*/_jsx("div", {
      className: "page-cushion-container",
      children: showCollectionDisplay ? /*#__PURE__*/_jsx(ShopCollectionPage, _objectSpread({}, props)) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [(_props$siasResponse = props.siasResponse) !== null && _props$siasResponse !== void 0 && (_props$siasResponse$s = _props$siasResponse.sias) !== null && _props$siasResponse$s !== void 0 && _props$siasResponse$s.length ? /*#__PURE__*/_jsx(ShopCatalogueBubbles, {
          catalogues: [],
          context: props.context,
          shop: props.shop,
          firstSIA: (_props$siasResponse2 = props.siasResponse) === null || _props$siasResponse2 === void 0 ? void 0 : _props$siasResponse2.sias[0],
          offers: props.offers
        }) : null, !props.context.isMobileView ? /*#__PURE__*/_jsx(UtilsSeparator, {
          spacingTop: DIMENSIONS.px_24,
          spacingBottom: DIMENSIONS.px_24,
          color: "gainsboro"
        }) : null, /*#__PURE__*/_jsx(ShopAggregationPage, _objectSpread({}, props))]
      })
    }), props.context.isMobileView ? /*#__PURE__*/_jsx(MobileFooter, {}) : /*#__PURE__*/_jsx(DesktopFooter, {})]
  });
}

function MobileShopAggregationPage(props) {
  var _useInfiniteQuery2 = useInfiniteQuery([PageCacheKeys.SHOP_PAGE, props.context.params[0], JSON.stringify(props.context.query)], function (_ref2) {
    var pageParam = _ref2.pageParam;
    return fetchProductsForPages(props.shop, pageParam, props.context);
  }),
      data = _useInfiniteQuery2.data,
      fetchNextPage = _useInfiniteQuery2.fetchNextPage,
      isLoading = _useInfiniteQuery2.isLoading;

  var onNextClick = function onNextClick(nextPage) {
    fetchNextPage({
      pageParam: nextPage
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [data && data.pages.map(function (page, index) {
      return /*#__PURE__*/_jsx(ProductStackList, {
        siaList: page.sias,
        context: props.context,
        sourceType: PageTypes.MARKETPLACE_SHOP_PAGE,
        sourceName: props.shop.name,
        disableVCUtm: props.context.query[UtmParams.UTM_MEDIUM] !== INTERNAL_NAVIGATION_UTM_MEDIUM,
        pageOffset: index * DEFAULT_PAGINATION_LIMIT
      }, index);
    }), data && data.pages.length < data.pages[0].siasCount / DEFAULT_PAGINATION_LIMIT ? /*#__PURE__*/_jsx(UtilsInfiniteScroll, {
      currPage: data.pages.length,
      callback: onNextClick,
      disableDefaultGutter: true
    }) : null, props.context.isMobileView ? /*#__PURE__*/_jsxs(UtilsStickyBottomCta, {
      className: "mt-12",
      usePositionFixed: true,
      children: [/*#__PURE__*/_jsx(SortFilterModalSheet, {
        context: props.context
      }), /*#__PURE__*/_jsx(FilterModalDialog, {
        context: props.context,
        filters: (data === null || data === void 0 ? void 0 : data.pages[0].filters) || []
      })]
    }) : null, isLoading && !data ? /*#__PURE__*/_jsx(PageLoader, {}) : null]
  });
}

function DesktopShopAggregationPage(props) {
  var _useQuery = useQuery([PageCacheKeys.SHOP_PAGE, props.context.params[0], props.currPage, JSON.stringify(props.context.query)], function () {
    return fetchProductsForPages(props.shop, props.currPage, props.context);
  }),
      data = _useQuery.data,
      isLoading = _useQuery.isLoading;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [data ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ProductStackList, {
        siaList: data.sias,
        context: props.context,
        sourceType: PageTypes.MARKETPLACE_SHOP_PAGE,
        sourceName: props.shop.name,
        disableVCUtm: props.context.query['utm_medium'] !== 'mp_routing',
        pageOffset: (props.currPage - 1) * DEFAULT_PAGINATION_LIMIT
      }), /*#__PURE__*/_jsx(UtilsSeparator, {
        spacingTop: DIMENSIONS.px_60,
        spacingBottom: DIMENSIONS.px_32,
        color: "gainsboro"
      }), /*#__PURE__*/_jsx(Pagination, {
        pathname: props.context.pathname,
        query: props.context.query,
        currentPage: props.siasCurrPage,
        totalCount: data.siasCount,
        paginationLimit: DEFAULT_PAGINATION_LIMIT
      })]
    }) : null, isLoading && !data ? /*#__PURE__*/_jsx(PageLoader, {}) : null]
  });
}

function ShopAggregationPage(props) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "pure-g",
      children: [!props.context.isMobileView ? /*#__PURE__*/_jsx("div", {
        className: "pure-u-5-24 pr-4",
        children: /*#__PURE__*/_jsx("div", {
          className: "px-4 pt-6",
          children: /*#__PURE__*/_jsx(CategoryFilters, {
            context: props.context,
            filterDetails: props.siasResponse.filters.filter(function (item) {
              return item.filterType === FilterTypes.Category;
            })[0],
            showPaginatedFilters: true
          })
        })
      }) : null, /*#__PURE__*/_jsxs("div", {
        className: props.context.isMobileView ? 'pure-u-1 pt-4' : 'pure-u-19-24 pt-8',
        children: [!props.siasResponse.sias.length ? /*#__PURE__*/_jsx(EmptyResults, {
          context: props.context
        }) : null, props.context.isMobileView ? /*#__PURE__*/_jsx(MobileShopAggregationPage, _objectSpread({}, props)) : /*#__PURE__*/_jsx(DesktopShopAggregationPage, _objectSpread({}, props))]
      })]
    })
  });
}

export default ShopPage;